import axios from "axios";
import store from "../store/index.js";
import { Environment } from "./Environment";

const instance = axios.create({
  baseURL: Environment.get("VUE_APP_API2_HOST") + "/api/",
  timeout: 20000,
  headers: {
    authorization: "Bearer " + localStorage.tablet_token,
  },
  params: {},
  //withCredentials: true
});

/* Safe this if you want to use this for later
instance.interceptors.request.use((config) => {
    console.log('Hola, request!')
    return config;
}, (error) => {
    console.log('Hola, response error!!!!', error)
    return Promise.reject(error);
});
*/

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function getBackoffDelay(retryCount, base = 200) {
  const jitter = Math.floor(Math.random() * 100);
  return Math.min(10000, base * 2 ** retryCount + jitter);
}

// Only retry on these
const RETRYABLE_STATUSES = [502, 503, 504];
const MAX_RETRIES = 3;

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const config = error.config;
    if (!config || config._retryCount >= MAX_RETRIES) {
      return Promise.reject(error);
    }

    const status = error.response?.status;

    // --- IMPROVEMENT 1: Differentiate network error from timeout ---
    const isTimeout = error.code === "ECONNABORTED";
    const isNetworkError = !status && !isTimeout;
    const isGatewayError = RETRYABLE_STATUSES.includes(status);
    const shouldRetry = isNetworkError || isGatewayError;
    // ---

    if (!shouldRetry) {
      if (error.response && error.response.status === 401) {
        store.dispatch("setToken", null);
        store.dispatch("setUser", null);
        localStorage.removeItem("token");
        console.log("Token expired, user logged out");
      }
      return Promise.reject(error);
    }

    config._retryCount = (config._retryCount || 0) + 1;

    // --- IMPROVEMENT 3: Only clear cookies on the first retry ---
    if (config._retryCount === 1) {
      document.cookie = "AWSALB=; Max-Age=0; path=/";
      document.cookie = "AWSALBTG=; Max-Age=0; path=/";
    }
    // ---

    // --- IMPROVEMENT 4: Using the faster backoff delay ---
    const backoff = getBackoffDelay(config._retryCount);
    console.log(
      `Api2 Retry #${config._retryCount} after ${backoff}ms for status ${
        status || "network error"
      }`
    );

    await delay(backoff);
    return instance(config);
  }
);

export default () => {
  return instance;
};
